export const formatBigAnalyticsNumber = (value?: number | null): string => {
  if (value === null || value === undefined || isNaN(value)) return '-';

  const absValue = Math.abs(value);

  if (absValue >= 1_000_000) {
    return (value / 1_000_000).toFixed(2).replace('.', ',') + 'млн';
  }

  if (absValue >= 1_000) {
    return (value / 1_000).toFixed(1).replace('.', ',') + 'тыс';
  }

  return value.toString();
};

export const formatAnalyticsPercentage = (value?: number | null): string => {
  if (value === null || value === undefined || isNaN(value)) return '-';

  if (value >= 100) {
    return '100%';
  }

  return Math.floor(value).toString() + '%';
};
